import { render, staticRenderFns } from "./ServiceOrderDetailsComponent.vue?vue&type=template&id=909916ee&"
import script from "./ServiceOrderDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports